export const CheckClientHeader = 'ancon go virtual pos' as const
